import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [status, setStatus] = useState("pending"); // pending | paid | expired | error
  const [info, setInfo] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const sid = url.searchParams.get("session_id");
    if (!sid) { setStatus("error"); return; }

    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sid}`);
        setInfo(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts >= 8) { setStatus("error"); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attempts >= 8) setStatus("error"); else setTimeout(poll, 2000);
      }
    };
    poll();
  }, []);

  const isActivation = info?.kind === "activation";

  return (
    <div className="bg-cream min-h-[80vh] flex items-center justify-center px-4">
      <div className="bg-[#131C2E] rounded-2xl border border-[#1F2A40] p-10 max-w-md w-full text-center animate-fade-up">
        {status === "pending" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto animate-spin text-terracotta" />
            <h2 className="font-display text-2xl mt-4">Confirming your payment…</h2>
            <p className="text-charcoal/60 mt-2">Hang tight, this takes a few seconds.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-sage" />
            <h2 className="font-display text-3xl mt-4">You're booked! 🎉</h2>
            <p className="text-charcoal/70 mt-2">We&apos;ve notified your Move-in Pro. They&apos;ll reach out soon.</p>
            <Link to="/dashboard" className="inline-block mt-6">
              <Button data-testid="go-dashboard-btn" className="rounded-full bg-terracotta hover:bg-terracotta/90 text-white btn-lift h-11 px-6">Go to dashboard</Button>
            </Link>
          </>
        )}
        {status === "expired" && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-destructive" />
            <h2 className="font-display text-2xl mt-4">Session expired</h2>
            <p className="text-charcoal/60 mt-2">Please try booking again.</p>
            <Button onClick={() => nav("/browse")} className="mt-5 rounded-full bg-terracotta hover:bg-terracotta/90 text-white">Browse</Button>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-destructive" />
            <h2 className="font-display text-2xl mt-4">We couldn't confirm the payment</h2>
            <p className="text-charcoal/60 mt-2">If you were charged, it will show in your dashboard within a minute.</p>
            <Button onClick={() => nav("/dashboard")} className="mt-5 rounded-full bg-terracotta hover:bg-terracotta/90 text-white">Open dashboard</Button>
          </>
        )}
      </div>
    </div>
  );
}
